export default __webpack_public_path__ + "static/wholesale-0e5d350cb8dd5833a91b5eb28f0f76ef.png";